import {
	get_interchange_assets, get_interchange_assets_type
	, get_interchange_assets_history, new_trade_sure, inventory, api_SellItem
} from '@/api';
import { conversion, typeRate, GetItemDuration } from "@/tool";
import { mapMutations, mapState } from "vuex";


import CustomButton from '@/partials/custom_button';

import Button from '@/components/button';
import InteractivePanel from '@/components/interactive_panel';
import Award from '@/components/award';
import Picture from '@/components/picture';
import { CustomBlockTitle } from '@/partials/custom_block_title';
import LuckBox from '@/partials/luck_box';
import StockAward from '@/components/stockAward';

export default {

	filters: {
		conversion,
		GetItemDuration
	},

	components: {
		'p-custom-block-title': CustomBlockTitle,
		'p-custom-button': CustomButton,
		'p-luckbox': LuckBox,
		'c-button': Button,
		'c-interactive-panel': InteractivePanel,
		'c-award': Award,
		'c-picture': Picture,
		'c-stockAward': StockAward
	},
	data() {
		return {
			price_range: 0,
			isFirst: true,    // 是否第一次进入页面
			assets_data: {
				flag: false,
				search_name: '',
				sort_price: 0,
				categoryId: 1,		//当前分类id
				sub_catetoryId: 0,//当前子分类ID
				sub_catetory_name: "",
				list_assets_data: {
					categories: [],
					items: []
				}
			},
			sounds: [],
			notice_modal_show: false,
			shouldRestoreScroll: false,
			savedScrollTop: 0
		};
	},
	computed: {
		...mapState(["user"]),
		active_assets_list() {

			return this.assets_data.list_assets_data.items
				.filter((item) => item.name.indexOf(this.assets_data.search_name) > -1)
		}
	},
	watch: {
		async isHappyCoin(val, oldVal) {
			if (val === oldVal) return;
			this.isFirst = true;
			await this.get_assets_type();
			await this.get_assets_list(0, 0);
		}
	},
	async created() {
		this.get_assets_type();
		// this.price_range = 5;  //进来默认加载2000-10000的数据
		this.get_assets_list(0, 0);
	},

	beforeDestroy() {
	},
	activated() {
		if (!this.shouldRestoreScroll) return;
		this.shouldRestoreScroll = false;
		this.restorePageScroll();
	},
	beforeRouteLeave(to, from, next) {
		if (to.name === "upgradeDetail" || to.name === "happyCoinUpgradeDetail" || to.name === "upgrade2Detail") {
			this.savedScrollTop = this.getPageScrollTop();
			this.shouldRestoreScroll = true;
		} else {
			this.shouldRestoreScroll = false;
			this.savedScrollTop = 0;
		}
		next();
	},


	methods: {

		...mapMutations(['setInfo', 'setPayModal', 'setloginModal', "setSpinShow"]),

		search_subcate(name, sub_cat) {
			this.assets_data.sub_catetoryId = sub_cat;
			if (name === "不限")
				this.assets_data.sub_catetory_name = "";
			else
				this.assets_data.sub_catetory_name = name;
		},
		getPageScrollContainer() {
			return document.querySelector(".p-home.mobile-home") || window;
		},
		getPageScrollTop() {
			const container = this.getPageScrollContainer();
			if (container === window) {
				return (
					window.pageYOffset ||
					document.documentElement.scrollTop ||
					document.body.scrollTop ||
					0
				);
			}
			return container.scrollTop || 0;
		},
		setPageScrollTop(top) {
			const container = this.getPageScrollContainer();
			if (container === window) {
				window.scrollTo({ top, behavior: "auto" });
				return;
			}
			container.scrollTo({ top, behavior: "auto" });
		},
		restorePageScroll() {
			const top = this.savedScrollTop;
			this.$nextTick(() => {
				setTimeout(() => {
					this.setPageScrollTop(top);
				}, 0);
			});
		},

		async get_assets_type() {
			var respone = await get_interchange_assets_type({ isHappyCoin: this.isHappyCoin, cat: this.assets_data.categoryId });

			this.assets_data.list_assets_data.categories = respone.data.data;
			this.assets_data.list_assets_data.categories.unshift({ name: "全部", imgUrl: require('@/assets/images/move.png'), parentName: null, sort: 1, id: 0, createTime: '', updatedTime: '' });
		},
		switch_get_assets_list(type, sort) {

			if (this.isFirst) {
				this.isFirst = false;
				this.price_range = 0;
			}
			this.get_assets_list(type, sort);
		},

		/** 获取初始列表 */
		async get_assets_list(type, sort) {

			this.assets_data.sort_price = sort;
			this.assets_data.categoryId = type;
			this.assets_data.search_name = '';
			this.search_subcate("", 0);

			var minprice = 0;
			var maxprice = 9999999;

			switch (this.price_range) {
				case 1:
					minprice = 0;
					maxprice = 50;
					break;
				case 2:
					minprice = 50;
					maxprice = 200;
					break;
				case 3:
					minprice = 200;
					maxprice = 1000;
					break;
				case 4:
					minprice = 1000;
					maxprice = 2000;
					break;
				case 5:
					minprice = 2000;
					maxprice = 10000;
					break;
				case 6:
					minprice = 10000;
					maxprice = 9999999;
					break;
				default:
					minprice = 0;
					maxprice = 9999999;
					break;
			}
			var params = {
				cat: this.assets_data.categoryId,
				size: 999999,
				minprice,
				maxprice,
				isHappyCoin: this.isHappyCoin
			};
			var respone = await get_interchange_assets(params);
			this.setSpinShow(false)
			//修改适配BabaAPI
			//this.assets_data.list_assets_data.items = respone.data.data.data;

			this.assets_data.list_assets_data.items = respone.data.data;

			if (sort == 1) {
				this.assets_data.list_assets_data.items.sort(function (a, b) {
					return a.price - b.price;
				});
			} else {
				this.assets_data.list_assets_data.items.sort(function (a, b) {
					return b.price - a.price;
				});
			}
		},
		selected_assets(item) {
			sessionStorage.setItem("upgradeSelectedItem", JSON.stringify(item));
			this.$router.push({
				name: this.isHappyCoin ? 'happyCoinUpgradeDetail' : 'upgradeDetail',
				params: { pitem: item },
				query: this.$route.query || {}
			});
		}

	},

}
